import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Approved from "../../../../assets/images/approved.png";
import Pending from "../../../../assets/images/pending 2.png";
import Add from "../../../../assets/images/UpcomingEvent/add 1.png";
import axios from "axios";

const Nav = () => {
  const [approved, setApproved] = useState("");
  const [pending, setPeding] = useState("");

  //Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/learning_session/count`).then((res) => {
      if (res.status === 200) {
        setApproved(res.data.approved);
        setPeding(res.data.pending);
      }
    });
  }, []);

  return (
    <>
      <div className="mb-3 row">
        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-2">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Approved} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                      {approved ? approved : "00"}
                    </small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar/learning-session/approved"
              className="card-footer livechat-card-footer"
            >
              <button
                className="livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Approved
              </button>
            </Link>
          </div>
        </div>
        <br />

        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-2">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Pending} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                      {pending ? pending : "00"}
                    </small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar/learning-session/pending"
              className="card-footer livechat-card-footer"
            >
              <button
                className="livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Pending
              </button>
            </Link>
          </div>
        </div>
        <br />

        <div
          title="Live Now"
          className="col-md-3 align-items-center justify-content-center "
        >
          <div className="card card-bg nav-body-dashboard mb-2">
            <div className="card-body  align-items-center">
              <center>
                <tr>
                  <td className="livechat-card-td">
                    <img src={Add} className="img-top" alt="..." />
                  </td>
                  <td className="livechat-card-td">
                    <small className="p-3 fw-bold rounded-1 text-warning textFontResult"></small>
                  </td>
                </tr>
              </center>
            </div>
            <Link
              to="/superstar/learning-session/create"
              className="livechat-card-footer"
            >
              <button
                className="card-footer livechat-card-footer"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Create Learning Session
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
